module.exports = __webpack_public_path__ + "img/logo_hemocir_white.659406e9.svg";